import EmailInput from './EmailInput';

export { emailRegExp } from './validate';

export default EmailInput;
